import { render, staticRenderFns } from "./SalaryInfoModalHeader.vue?vue&type=template&id=f8fd5314&"
import script from "./SalaryInfoModalHeader.vue?vue&type=script&lang=ts&"
export * from "./SalaryInfoModalHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports